@if (modalType == _assignmentsService.modalTypes.assignToMeModal) {
  <div class="modal-dialog modal-md">
    <div class="modal-content border-0">
      <form [formGroup]="assignToMeForm" (ngSubmit)="handleAssignToMe()">
        <div class="modal-header bg-primary d-flex align-items-center justify-content-between">
          <h4 class="modal-title text-white fs-18">Assign to Me</h4>
          <img src="assets/images/icons/white-cross.svg" alt="" (click)="cancel()" class="cursor hw-24">
        </div>
        <div class="modal-body">
          <p>Are you sure you want to assign this assignment to yourself?</p>
          <div class="form-group">
            <label for="notes2" class="fs-">Notes*</label>
            <textarea formControlName="notes" id="notes" rows="4" placeholder="Enter your notes here."
            class="input_field" [ngClass]="{'is-invalid': assignToMeForm.get('notes')?.invalid && assignToMeForm.get('notes')?.touched}"></textarea>
            @if (assignToMeForm.get('notes')?.invalid && assignToMeForm.get('notes')?.touched) {
              <p class="text-danger fs-10 fw-500">
              * Please enter a note</p>
            }
          </div>
        </div>
        <div class="modal-footer">
          <div class="d-flex justify-content-end w-100">
            <button type="button" class="btn btn-outline me-2"
            (click)="cancel()">Cancel</button>
            <button type="submit" class="btn btn-primary" [disabled]="assignToMeForm.invalid">Assign</button>
          </div>
        </div>
      </form>
    </div>
  </div>
}

@if (modalType == _assignmentsService.modalTypes.deleteModal) {
  <div class="modal-dialog modal-md">
    <div class="modal-content border-0">
      <form [formGroup]="deleteForm" (ngSubmit)="handleDelete()">
        <div class="modal-header bg-primary d-flex align-items-center justify-content-between">
          <h4 class="modal-title text-white fs-18">Delete Assignment</h4>
          <img src="assets/images/icons/white-cross.svg" alt="" (click)="cancel()" class="cursor hw-24">
        </div>
        <div class="modal-body">
          <p>Are you sure you want to delete this assignment?</p>
          <div class="form-group">
            <label for="notes2" class="fs-14 fw-400 m-0">Notes*</label>
            <textarea formControlName="notes" trim="blur" id="notes" rows="4"
              placeholder="Enter your notes here." class="input_field"
            [ngClass]="{'is-invalid': deleteForm.get('notes')?.invalid && deleteForm.get('notes')?.touched}"></textarea>
            @if (deleteForm.get('notes')?.invalid && deleteForm.get('notes')?.touched) {
              <p class="text-danger fs-10 fw-500">* Please
              enter a note</p>
            }
          </div>
        </div>
        <div class="modal-footer">
          <div class="text-end">
            <button type="button" class="btn btn-outline me-3"
            (click)="cancel()">No</button>
            <button type="submit" class="btn btn-primary"
            [disabled]="deleteForm.invalid">Yes</button>
          </div>
        </div>
      </form>
    </div>
  </div>
}

@if (modalType == _assignmentsService.modalTypes.ticketAssignToMeModal) {
  <div class="modal-dialog modal-md">
    <div class="modal-content border-0">
      <form [formGroup]="phaseAssignToMeForm" (ngSubmit)="assignTicket()">
        <div class="modal-header bg-primary d-flex align-items-center justify-content-between">
          <h4 class="modal-title text-white fs-18">Assign To</h4>
          <img src="assets/images/icons/white-cross.svg" alt="" (click)="cancel()" class="cursor hw-24">
        </div>
        <div class="modal-body">
          <div class="d-flex align-items-center mb-3">
            <span class="pe-2 fs-14 fw-400 m-0" >Change Full Details</span>
            <label class="switch switch-md switch-success vertical-bottom">
              <input
                type="checkbox"
                [checked]="only_assign_button"
                (change)="changeToggle($event)"
                name="only_assign_button"
                />
                <span class="slider"></span>
              </label>
              <span class="ps-2 fs-14 fw-400 m-0">Change Only Assignee</span>
            </div>
            @if (!only_assign_button) {
              <div class="form-group">
                <label for="status"  class="fs-14 fw-400 m-0">Status</label>
                <div class="input_field py-0">
                  <select formControlName="status" name="status" id="status"
                    class="input_field selectType m-0 px-0 border-0">
                    <option value="" disabled>Please Select</option>
                    <option value="0">Pending</option>
                    <option value="3">Follow Up</option>
                  </select>
                </div>
              </div>
            }
            @if (phase_extra_data.status != 1) {
              <div class="form-group row">
                @if (!only_assign_button) {
                  <div class="col" >
                    <label for="" class="fs-14 fw-400 m-0">Follow Date* </label>
                    <div class="d-flex align-items-center input_field p-0 overflow-hidden">
                      <input formControlName="followupDate" name="followupDate"
                        class="input_field border-0 border-end m-0 flex-fill rounded-0" bsDatepicker readonly #dp="bsDatepicker" [bsConfig]="dateConfig" [minDate]="minDate"
                        placeholder="Choose a date">
                        <div class="bg-transparent border-0 h-100 hw-40 d-flex align-items-center justify-content-center" (click)="dp.toggle()">
                          <i class="fa fa-calendar"></i>
                        </div>
                      </div>
                      @if (phaseAssignToMeForm.get('followupDate')?.invalid && phaseAssignToMeForm.get('followupDate')?.touched) {
                        <p class="text-danger fs-10 fw-500">Please
                        select follow up date.</p>
                      }
                    </div>
                  }
                  @if (!only_assign_button) {
                    <div class="col" >
                      <label for="" class="fs-14 fw-400 m-0 mb-2">Followup Time1({{timezoneName}})*
                        <i class="ml-1 fa fa-info-circle" tooltip="Please set followup time in 24 hour format."></i>
                      </label>
                      <div class="row">
                        <div class="col-6">
                          <ngx-select [items]="hours" optionValueField="value" optionTextField="value" name="value"
                            [allowClear]="false" placeholder="HH" formControlName="followup_hour">
                            <ng-template ngx-select-option-selected let-option>
                              {{option.data.value}}
                            </ng-template>
                            <ng-template ngx-select-option-not-found>
                              Not found
                            </ng-template>
                          </ngx-select>
                        </div>
                        <div class="col-6">
                          <ngx-select [items]="minutes" optionValueField="value" optionTextField="value" name="value"
                            [allowClear]="false" placeholder="MM" formControlName="followup_minutes">
                            <ng-template ngx-select-option-selected let-option>
                              {{option.data.value}}
                            </ng-template>
                            <ng-template ngx-select-option-not-found>
                              Not found
                            </ng-template>
                          </ngx-select>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              @if (phase_extra_data.status != 1) {
                <div class="form-group">
                  <label for=""  class="fs-14 fw-400 m-0 mb-2">Assign To</label>
                  <ngx-select [items]="admin_list" name="admin_assign" optionValueField="admin_id" optionTextField="admin_name"
                    (select)="selectAssignedAdmin($event)" [allowClear]="true" (selectionChanges)="assignedAdminClear($event)" placeholder="please enter assign to">
                    <ng-template ngx-select-option-selected let-option>
                      {{option.data.admin_name + ' ('+option.data.admin_email+')'}}
                    </ng-template>
                    <ng-template ngx-select-option let-option let-text="text">
                      {{option.data.admin_name}} <br>
                      <small>{{option.data.admin_email}}</small>
                    </ng-template>
                    <ng-template ngx-select-option-not-found>
                      Not found
                    </ng-template>
                  </ngx-select>
                </div>
              }
              <div class="form-group">
                <label for="notes2"  class="fs-14 fw-400 m-0">Notes*</label>
                <textarea required name="notes" trim="blur" id="notes" rows="4" placeholder="Enter your notes here." class="input_field"
                [ngClass]="{'is-invalid':phaseAssignToMeForm.get('notes')?.invalid && phaseAssignToMeForm.get('notes')?.touched}" formControlName="notes"></textarea>
                @if (phaseAssignToMeForm.get('notes')?.invalid && phaseAssignToMeForm.get('notes')?.touched) {
                  <p class="text-danger fs-10 fw-500">* Please
                  enter a note</p>
                }
              </div>
            </div>
            <div class="modal-footer">
              <div class="d-flex justify-content-end">
                <button type="button" class="btn btn-outline me-2"
                (click)="cancel()">Cancel</button>
                <button type="submit" class="btn btn-primary"  [disabled]="phaseAssignToMeForm.invalid">Assign</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    }

    <!--Approve Reject-->
    @if (modalType == _assignmentsService.modalTypes.approveRejectModal) {
      <div class="modal-dialog modal-md">
        <div class="modal-content border-0">
          <form [formGroup]="approveForm" (ngSubmit)="handleApproveReject()">
            <div class="modal-header bg-primary d-flex align-items-center justify-content-between">
              @if (approve_extra_data) {
                <h4 class="modal-title text-white fs-18">{{approve_extra_data.is_approved == 1?'Approve':'Reject'}}</h4>
              }
              <img src="assets/images/icons/white-cross.svg" alt="" (click)="cancel()" class="cursor hw-24">
            </div>
            @if (approve_extra_data) {
              <div class="modal-body">
                <div class="form-group">
                  <label for="">Assign To</label>
                  <ngx-select [items]="admin_list" optionValueField="admin_id" optionTextField="admin_name"
                    (select)="selectAssignedAdmin($event)" [allowClear]="true" (selectionChanges)="assignedAdminClear($event)"
                    placeholder="please enter assign to" formControlName="admin_id"
                    name="assigned_to">
                    <ng-template ngx-select-option-selected let-option>
                      {{option.data.admin_name + ' ('+option.data.admin_email+')'}}
                    </ng-template>
                    <ng-template ngx-select-option let-option let-text="text">
                      {{option.data.admin_name}} <br>
                      <small>{{option.data.admin_email}}</small>
                    </ng-template>
                    <ng-template ngx-select-option-not-found>
                      Not found
                    </ng-template>
                  </ngx-select>
                </div>
                <div class="form-group">
                  <label for="notes2">Notes</label>
                  <textarea required name="notes" trim="blur" id="notes" rows="4"
                    formControlName="notes" placeholder="Enter your notes here."
                    class="input_field"
                  [ngClass]="{'is-invalid':approveForm.get('notes')?.invalid && approveForm.get('notes')?.touched}"></textarea>
                  @if (approveForm.get('notes')?.invalid && approveForm.get('notes')?.touched) {
                    <p class="text-danger fs-10 fw-500">*
                      Please enter a
                    note</p>
                  }
                </div>
              </div>
            }
            <div class="modal-footer">
              <div class="d-flex justify-content-between" style="width:100%;">
                <div class="flex-1">
                  <button type="button" class="btn btn-outline"
                  (click)="cancel()">Cancel</button>
                </div>
                <div class="flex-2">
                  <button type="submit" class="btn btn-primary" (click)="approveForm.valid"
                  [disabled]="approveForm.invalid">Confirm</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    }


    <!--Change Status-->
    @if (modalType == _assignmentsService.modalTypes.changeStatusModal) {
      <div class="modal-dialog modal-md">
        <div class="modal-content border-0">
          <form [formGroup]="changeStatusForm" (ngSubmit)="changeStatus()">
            <div class="modal-header bg-primary d-flex align-items-center justify-content-between">
              <h4 class="modal-title text-white fs-18">Change Status / Reassign</h4>
              <img src="assets/images/icons/white-cross.svg" alt="" (click)="cancel()" class="cursor hw-24">
            </div>
            @if (change_status_data) {
              <div class="modal-body">
                <div class="form-group">
                  <label for="status" class="fs-14 fw-400 m-0">Status</label>
                  <div class="input_field py-0">
                    <select name="status" id="status" required formControlName="status"
                      class="input_field selectType m-0 px-0 border-0" [ngClass]="{'is-invalid':changeStatusForm.get('status')?.invalid && changeStatusForm.get('status')?.touched}" [(ngModel)]="change_status_data.status">
                      <option value="" disabled selected>Please Select</option>
                      @if (change_status_data.status == 0) {
                        <option value="0">Pending</option>
                      }
                      @if (!change_status_data.phase_req_id || (change_status_data.phase_req_id && (change_status_data.role == 1 ||change_status_data.role == 4 || change_status_data.role == 9 || change_status_data.role == 13 || change_status_data.role == 7))) {
                        <option value="1"
                          >
                          Closed
                        </option>
                      }
                      <option value="2">Re-Open</option>
                      <option value="3">Follow Up</option>
                    </select>
                  </div>
                </div>
                @if (change_status_data?.status != 1) {
                  <div class="form-group row">
                    <div class="col">
                      <label for="type_of_call" class="fs-14 fw-400 m-0">Type of Contact</label>
                      <div class="input_field py-0">
                        <select name="t_o_c" id="t_o_c" class="input_field selectType m-0 px-0 border-0" formControlName="type_of_call" (change)="updateField('type_of_call', $event)" >
                          <option value="0" selected disabled >Select Contact Type</option>
                          @for (t_o_c of change_status_data.type_of_call_arr; track t_o_c) {
                            <option [value]="t_o_c.contact_id">{{t_o_c.contact_name}}</option>
                          }
                        </select>
                      </div>
                    </div>
                    @if (![6, 7, 8].includes($safeNavigationMigration(change_status_data?.type_of_call))) {
                      <div class="col">
                        <label for="result_of_contact" class="fs-14 fw-400 m-0">Result of contact</label>
                        <div class="input_field py-0">
                          <select name="r_o_c" id="r_o_c" class="input_field selectType m-0 px-0 border-0" formControlName="result_of_contact" (change)="updateField('result_of_contact', $event)" [disabled]="!change_status_data.type_of_call || change_status_data.type_of_call == '9' ">
                            <option value="0" selected disabled >Select Contact Result</option>
                            @for (r_o_c of change_status_data.result_of_contact_arr; track r_o_c) {
                              <option [value]="r_o_c.result_id">{{r_o_c.result_value}}</option>
                            }
                          </select>
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (change_status_data.status != 1) {
                  <div class="form-group row">
                    <div class="col">
                      <label for="" class="fs-14 fw-400 m-0">Follow Date*</label>
                      <div class="input-group d-flex align-items-center input_field p-0 overflow-hidden">
                        <div class="d-flex align-items-center" style="width: 100%;">
                          <input required formControlName="followupDate" name="followupDate" class="input_field border-0 border-end m-0 flex-fill rounded-0" bsDatepicker readonly #dp="bsDatepicker"
                            [bsConfig]="dateConfig" [minDate]="minDate" style="background: #ffffff;" placeholder="Choose a date">
                            <div class="bg-transparent border-0 h-100 hw-40 d-flex align-items-center justify-content-center" (click)="dp.toggle()">
                              <i class="fa fa-calendar"></i>
                            </div>
                          </div>
                          <div class="input-group-append">
                            <!-- <button type="button" (click)="bsDatepicker.toggle()" class="btn rounded"><i class="fa fa-calendar"></i></button> -->
                          </div>
                        </div>
                        @if (changeStatusForm.get('followupDate')?.invalid && changeStatusForm.get('followupDate')?.touched) {
                          <p class="text-danger fs-10 fw-500">Please
                          select follow up date.</p>
                        }
                      </div>
                      <div class="col">
                        <label for="" class="fs-14 fw-400 m-0">Followup Time({{timezoneName}})*
                          <i class="ml-1 fa fa-info-circle" tooltip="Please set followup time in 24 hour format."></i>
                        </label>
                        <div class="row my-2">
                          <div class="col-6">
                            <ngx-select [items]="hours" optionValueField="value" optionTextField="value" name="value"
                              [allowClear]="false" placeholder="HH" formControlName="followup_hour">
                              <ng-template ngx-select-option-selected let-option>
                                {{option.data.value}}
                              </ng-template>
                              <ng-template ngx-select-option-not-found>
                                Not found
                              </ng-template>
                            </ngx-select>
                          </div>
                          <div class="col-6">
                            <ngx-select [items]="minutes" optionValueField="value" optionTextField="value" name="value"
                              [allowClear]="false" placeholder="MM" formControlName="followup_minutes">
                              <ng-template ngx-select-option-selected let-option>
                                {{option.data.value}}
                              </ng-template>
                              <ng-template ngx-select-option-not-found>
                                Not found
                              </ng-template>
                            </ngx-select>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  @if (change_status_data.status != 1) {
                    <div class="form-group">
                      <label for="" class="fs-14 fw-400 m-0 mb-2">Assign To</label>
                      <ngx-select [items]="admin_list" optionValueField="admin_id" optionTextField="admin_name" name="admin_name"
                        (select)="selectAssignedAdmin($event)" [allowClear]="true" (selectionChanges)="assignedAdminClear($event)"
                        placeholder="please enter assign to" formControlName="admin_id">
                        <ng-template ngx-select-option-selected let-option>
                          {{option.data.admin_name + ' ('+option.data.admin_email+')'}}
                        </ng-template>
                        <ng-template ngx-select-option let-option let-text="text">
                          {{option.data.admin_name}} <br>
                          <small>{{option.data.admin_email}}</small>
                        </ng-template>
                        <ng-template ngx-select-option-not-found>
                          Not found
                        </ng-template>
                      </ngx-select>
                    </div>
                  }
                  <div class="form-group">
                    <label for="notes" class="fs-14 fw-400 m-0">Notes</label>
                    <textarea [ngClass]="{'is-invalid':changeStatusForm.get('notes')?.invalid && changeStatusForm.get('notes')?.touched}" required name="notes"
                      id="notes" rows="4" formControlName="notes"
                    placeholder="Enter your notes here." class="input_field" trim="blur"></textarea>
                    @if (changeStatusForm.get('notes')?.invalid && changeStatusForm.get('notes')?.touched) {
                      <p class="text-danger fs-10 fw-500">* Please enter
                      a note</p>
                    }
                  </div>
                  <div class="col p-0">
                    <div class="text-end">
                      <label for="images" class="btn btn-link p-0">Attach Image/Document</label>
                      <input type="file" name="" id="images" #imageElement
                        accept=".gif, .jpeg, .jpg, .png, .doc,.docx,application/msword, .pdf, .xls,.xlsx, .csv"
                        (change)="fileSelect($event)" class="d-none">
                      </div>
                      @for (file of images; track file; let i = $index) {
                        <div>
                          @if (file.subs && file.subs[0]) {
                            <div>
                              @if (file.subs[0].message) {
                                <div class="d-flex">
                                  <progressbar [value]="file.subs[0].message" type="warning" [striped]="true">
                                  {{file.subs[0].message}}%</progressbar>
                                  <i class="fa fa-close ml-2" tappable tooltip="Cancel upload" (click)="cancelImageUpload(file, i)"></i>
                                </div>
                              }
                              @if (file.subs[0].images && file.subs[0].images[0]) {
                                <div
                                  class="d-flex justify-content-between align-items-center border mb-1">
                                  <span>
                                    <i class="fa fa-trash text-danger fs-10 fw-500 mr-2" (click)="deleteFile(file.image, i)"
                                    tooltip="Delete uploaded file" tappable></i>
                                    <a [href]="file.image" target="_blank">Click here to view</a>
                                  </span>
                                  <i class="fa fa-check text-success" tooltip="File Uploaded"></i>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
                <div class="modal-footer">
                  <div class="row">
                    <div class="col pr-1">
                      <button type="button" class="btn btn-default" (click)="cancel()">No</button>
                    </div>
                    <div class="col">
                      <button type="submit" class="btn btn-primary" (click)="changeStatusForm.valid" [disabled]="changeStatusForm.invalid || change_status_data.uploading">Yes</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        }


        @if (modalType == _assignmentsService.modalTypes.addNoteModal) {
          <div class="modal-dialog modal-md">
            <div class="modal-content border-0">
              <form [formGroup]="addNoteForm" (ngSubmit)="addNote()">
                <div class="modal-header bg-primary d-flex align-items-center justify-content-between">
                  <h4 class="modal-title text-white fs-18">Add Notes</h4>
                  <img src="assets/images/icons/white-cross.svg" alt="" (click)="cancel()" class="cursor hw-24">
                </div>
                @if (change_status_data) {
                  <div class="modal-body">
                    <div class="form-group">
                      <label for="notes" class="fs-14 fw-400 m-0">Notes</label>
                      <textarea required name="notes" id="notes" rows="4" formControlName="notes"
                        placeholder="Enter your notes here." class="input_field"
                      [ngClass]="{'is-invalid':addNoteForm.get('notes')?.invalid && addNoteForm.get('notes')?.touched}"></textarea>
                      @if (addNoteForm.get('notes')?.invalid && addNoteForm.get('notes')?.touched) {
                        <p class="text-danger fs-10 fw-500">* Please enter a
                        note</p>
                      }
                    </div>
                    <div class="col p-0">
                      <div class="text-end">
                        <label for="images" class="btn btn-primary btn-sm rounded">Attach Image/Document</label>
                        <input type="file" name="" id="images" #imageElement
                          accept=".gif, .jpeg, .jpg, .png, .doc,.docx,application/msword, .pdf, .xls,.xlsx, .csv"
                          (change)="fileSelect($event)" class="d-none">
                        </div>
                        @for (file of images; track file; let i = $index) {
                          <div>
                            @if (file.subs && file.subs[0]) {
                              <div>
                                @if (file.subs[0].message) {
                                  <div class="d-flex">
                                    <progressbar [value]="file.subs[0].message" type="warning" [striped]="true">
                                    {{file.subs[0].message}}%</progressbar>
                                    <i class="fa fa-close ml-2" tappable tooltip="Cancel upload" (click)="cancelImageUpload(file, i)"></i>
                                  </div>
                                }
                                @if (file.subs && file.subs[0].images && file.subs[0].images[0]) {
                                  <div
                                    class="d-flex justify-content-between align-items-center border mb-1">
                                    <span>
                                      <i class="fa fa-trash text-danger mr-2 pe-all" (click)="deleteFile(file.subs[0].images[0], i)"
                                      tooltip="Delete uploaded file" tappable></i>
                                      <a [href]="file.subs[0].images[0]" target="_blank">Click here to view</a>
                                    </span>
                                    <i class="fa fa-check text-success" tooltip="File Uploaded"></i>
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                  <div class="modal-footer text-end">
                    <div>
                      <button type="submit" class="btn btn-primary" (click)="addNoteForm.valid"
                      [disabled]="addNoteForm.invalid || change_status_data.uploading">Add</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          }


          <!-- Udpate assignment inquiry-->
          @if (modalType == _assignmentsService.modalTypes.updateInformationInquiryModal) {
            <div class="modal-dialog modal-lg">
              @if (update_extra_data && update_extra_data.wp_query_id) {
                <div class="modal-content border-0">
                  <form [formGroup]="updateForm" (ngSubmit)="updateInquiry()">
                    <div class="modal-header bg-primary d-flex align-items-center justify-content-between">
                      <h4 class="modal-title text-white fs-18">Update Inquiry Information</h4>
                      <img src="assets/images/icons/white-cross.svg" alt="" (click)="cancel()" class="cursor hw-24">
                    </div>
                    <div class="modal-body">
                      <div class="form-row row">
                        <div class="form-group col-md-6">
                          <label for="name">Name*</label>
                          <input type="text" required name="wp_name" trim="blur" id="wp_name" formControlName="wp_name"
                            placeholder="Enter name" class="input_field">
                            @if (updateForm.get('wp_name')?.invalid && updateForm.get('wp_name')?.touched) {
                              <p class="text-danger fs-10 fw-500">* Please enter name
                              </p>
                            }
                          </div>
                          <div class="form-group col-md-6">
                            <label for="email">Email*</label>
                            <input formControlName="wp_email" email required
                              name="wp_email" class="input_field" type="email" autocomplete="none">
                              @if (updateForm.get('wp_email')?.invalid && updateForm.get('wp_email')?.touched) {
                                <p class="text-danger fs-10 fw-500">* Please enter
                                email</p>
                              }
                            </div>
                            <div class="form-group col-md-6">
                              <label for="phone">Phone*</label>
                              <input type="text" required class="input_field" id="wp_phone" name="wp_phone"
                                placeholder="Enter phone." formControlName="wp_phone" />
                                @if (updateForm.get('wp_phone')?.invalid && updateForm.get('wp_phone')?.touched) {
                                  <p class="text-danger fs-10 fw-500">* Please enter
                                  phone</p>
                                }
                              </div>
                              <div class="form-group col-md-6">
                                <label for="phone">Specialty* </label>
                                <select name="wp_speciality" id="wp_speciality" formControlName="wp_speciality"
                                  class="input_field">
                                  <option value="0" selected>All</option>
                                  @for (ind of update_extra_data.industries; track ind) {
                                    <optgroup label="{{ind.ind_name}}">
                                      @for (spec of ind.specialities; track spec) {
                                        <option [value]="spec.speciality_name">{{spec.speciality_name}}
                                        </option>
                                      }
                                    </optgroup>
                                  }
                                </select>
                              </div>
                              <div class="form-group col-md-6">
                                <label for="wp_zip">Zip*</label>
                                <input type="text" readonly required name="wp_zip" trim="blur" id="wp_zip"
                                  formControlName="wp_zip" class="input_field">
                                </div>
                                <div class="form-group col-md-6">
                                  <label for="wp_address">Address*</label>
                                  <app-google-zip class="w-100" (setAddress)="selectZip($event)"
                                    id="wp_address" [country_code]="country_code"
                                    [address]="update_extra_data.assignment.wp_address">
                                  </app-google-zip>
                                </div>
                                <div class="form-group col-md-6">
                                  <label for="wp_city_name">City*</label>
                                  <input type="text" readonly required name="wp_city_name" trim="blur" id="wp_city_name"
                                    formControlName="wp_city_name" class="input_field">
                                  </div>
                                  <div class="form-group col-md-6">
                                    <label for="wp_state_name">State*</label>
                                    <input type="text" readonly required name="wp_state_name" trim="blur" id="wp_state_name"
                                      formControlName="wp_state_name"
                                      class="input_field">
                                    </div>
                                    <div class="form-group col-md-12">
                                      <label for="travel">Can travel upto miles*</label>
                                      <input type="text" required name="wp_distance" trim="blur" id="wp_distance"
                                        formControlName="wp_distance" class="input_field">
                                        @if (updateForm.get('wp_distance')?.invalid && updateForm.get('wp_distance')?.touched) {
                                          <p class="text-danger fs-10 fw-500">* Please
                                          enter travel upto</p>
                                        }
                                      </div>
                                      <div class="form-group col-md-6">
                                        <label for="notes2">Message*</label>
                                        <textarea type="text" required name="wp_message" trim="blur" id="wp_message" rows="4"
                                          formControlName="wp_message" placeholder="Enter your notes here."
                                        class="input_field"></textarea>
                                        @if (updateForm.get('wp_message')?.invalid && updateForm.get('wp_message')?.touched) {
                                          <p class="text-danger fs-10 fw-500">*
                                          Please enter a note</p>
                                        }
                                      </div>
                                      <div class="form-group col-md-6">
                                        <label for="notes2">Notes*</label>
                                        <textarea type="text" required name="update_note" trim="blur" id="update_note" rows="4"
                                          formControlName="update_note" placeholder="Enter your notes here."
                                        class="input_field"></textarea>
                                        @if (updateForm.get('update_note')?.invalid && updateForm.get('update_note')?.touched) {
                                          <p class="text-danger fs-10 fw-500">*
                                          Please enter a note</p>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                  <div class="modal-footer">
                                    <div class="d-flex justify-content-between" style="width:100%;">
                                      <div class="flex-1">
                                        <button type="button" class="btn btn-outline"
                                        (click)="cancel()">Cancel</button>
                                      </div>
                                      <div class="flex-2">
                                        <button type="submit" [disabled]="updateForm.invalid" class="btn btn-primary">Confirm</button>
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            }
                          </div>
                        }


                        @if (modalType == _assignmentsService.modalTypes.viewDocuments) {
                          <div class="modal-dialog modal-lg">
                            <div class="modal-content border-0" >
                              <form>
                                <div class="modal-header bg-primary d-flex align-items-center justify-content-between">
                                  <h4 class="modal-title text-white fs-18">Documents Uploaded By Business</h4>
                                  <img src="assets/images/icons/white-cross.svg" alt="" (click)="cancel()" class="cursor hw-24">
                                </div>
                                <div class="modal-body">
                                  <ul class="decoration-none  p-0">
                                    <li>
                                      @if (uploaded_doc && uploaded_doc.length > 0) {
                                        <h3 class="fw-500 text-muted">Uploaded Documents</h3>
                                      }
                                      <ol>
                                        @for (item of uploaded_doc; track item; let i = $index) {
                                          <li class="mb-3">
                                            <div class="d-flex align-items-center justify-content-between mb-2">
                                              <a [href]="item.doc_url" target="_blank" class="fs-14  fw-500 m-0">
                                                {{item.document_name}} @if (item.show_document == 1) {
                                                <span>( Old Document )</span>
                                              }
                                            </a>
                                            @if (needMore && item.show_document != 1 && item.need_more_document != 1) {
                                              <div class="">
                                                <input class="secondary-checkbox" type="checkbox" value="0" [id]="'doc1'+ i"><label tappable
                                              class="fs-14 fw-400 m-0" [for]="'doc1'+ i" (click)="toggleSelect(i,1)"></label>
                                            </div>
                                          }
                                        </div>
                                        @if (item.selected) {
                                          <div class=" btn-group w-100" dropdown>
                                            <button id="button-basic" dropdownToggle type="button"
                                              class="w-100 border radius-4 px-3 py-1 bg-white d-flex align-items-center justify-content-between dropdown-toggle"
                                              aria-controls="dropdown-basic">
                                              {{item.reason || "Select Reason"}}
                                              <span class="caret"></span>
                                            </button>
                                            <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu cursor" role="menu" aria-labelledby="button-basic">
                                              @for (item of reasons; track item; let t = $index) {
                                                <li role="menuitem" class="px-2" (click)="selectedReason(t,i,1)">
                                                  {{t+1}}. {{item.reason_value}}
                                                </li>
                                              }
                                            </ul>
                                          </div>
                                        }
                                      </li>
                                    }
                                  </ol>
                                </li>
                                @if (document_data.assignment_detail.status != 1 && remaining_doc.length > 0) {
                                  <li>
                                    <h3 class="fw-500 text-muted">Remaining Documents</h3>
                                    <ol>
                                      @for (item of remaining_doc; track item; let i = $index) {
                                        <li class="mb-3">
                                          <div class="d-flex align-items-center justify-content-between mb-2">
                                            <p class="fs-14  fw-500 m-0">
                                              {{item.document_name}}
                                            </p>
                                            @if (needMore) {
                                              <div class="">
                                                <input class="secondary-checkbox" type="checkbox" value="0" [id]="'doc'+ i"><label tappable
                                              class="fs-14 fw-400 m-0" [for]="'doc'+ i" (click)="toggleSelect(i,2)"></label>
                                            </div>
                                          }
                                        </div>
                                      </li>
                                    }
                                  </ol>
                                </li>
                              }
                            </ul>
                            @if (document_data.assignment_detail.status != 1) {
                              <textarea name="notes" id="notes" rows="4"  [(ngModel)]="note"
                              placeholder="Enter your notes here." class="input_field"></textarea>
                            }
                          </div>
                          @if (document_data.assignment_detail.status != 1) {
                            <div class="modal-footer d-flex align-items-center justify-content-between">
                              @if (show_need_more_document && !needMore) {
                                <button type="button" class="btn btn-primary" (click)="needMore = !needMore">Need More Documents</button>
                              }
                              @if (needMore) {
                                <button type="submit" class="btn btn-primary" (click)="needMore = !needMore" >Back</button>
                              }
                              @if (!needMore) {
                                <button type="submit" class="btn btn-primary" (click)="approveOrNeedMoreDocument(1)" >Approve</button>
                              }
                              @if (needMore) {
                                <button type="submit" class="btn btn-primary" (click)="approveOrNeedMoreDocument(2)" >send</button>
                              }
                            </div>
                          }
                        </form>
                      </div>
                    </div>
                  }
@if (modalType == _assignmentsService.modalTypes.editShipmentModal) {
  <div class="modal-dialog modal-lg">
    <div class="modal-content border-0">
      <form [formGroup]="editShipmentForm" (ngSubmit)="handleEditShipment()">
        <div class="modal-header bg-primary d-flex align-items-center justify-content-between">
          <h4 class="modal-title text-white fs-18">Edit Shipment Details</h4>
          <img src="assets/images/icons/white-cross.svg" alt="" (click)="cancel()" class="cursor hw-24">
        </div>
        <div class="modal-body">

          <p class="fs-16 fw-600 hex-65-grey border-bottom pb-2 mb-3">Device &amp; Tracking</p>
          <div class="row">
            <div class="col-md-6 col-12">
              <div class="form-group">
                <label for="serial_number" class="fs-14 fw-400 m-0">Serial Number <span class="text-danger">*</span></label>
                <input type="text" id="serial_number" formControlName="serial_number" class="input_field"
                  placeholder="Enter serial number"
                  [ngClass]="{'is-invalid': editShipmentForm.get('serial_number')?.invalid && editShipmentForm.get('serial_number')?.touched}">
                @if (editShipmentForm.get('serial_number')?.invalid && editShipmentForm.get('serial_number')?.touched) {
                  <p class="text-danger fs-10 fw-500">* Please enter a serial number</p>
                }
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div class="form-group">
                <label for="tracking_number" class="fs-14 fw-400 m-0">Tracking Number <span class="text-danger">*</span></label>
                <input type="text" id="tracking_number" formControlName="tracking_number" class="input_field"
                  placeholder="Enter tracking number"
                  [ngClass]="{'is-invalid': editShipmentForm.get('tracking_number')?.invalid && editShipmentForm.get('tracking_number')?.touched}">
                @if (editShipmentForm.get('tracking_number')?.invalid && editShipmentForm.get('tracking_number')?.touched) {
                  <p class="text-danger fs-10 fw-500">* Please enter a tracking number</p>
                }
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div class="form-group">
                <label for="track_link" class="fs-14 fw-400 m-0">Track Link <span class="text-danger">*</span></label>
                <input type="text" id="track_link" formControlName="track_link" class="input_field"
                  placeholder="https://"
                  [ngClass]="{'is-invalid': editShipmentForm.get('track_link')?.invalid && editShipmentForm.get('track_link')?.touched}">
                @if (editShipmentForm.get('track_link')?.invalid && editShipmentForm.get('track_link')?.touched) {
                  <p class="text-danger fs-10 fw-500">* Please enter a track link</p>
                }
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div class="form-group">
                <label for="carrier_name" class="fs-14 fw-400 m-0">Carrier Name <span class="text-danger">*</span></label>
                <input type="text" id="carrier_name" formControlName="carrier_name" class="input_field"
                  placeholder="USPS, UPS, FedEx"
                  [ngClass]="{'is-invalid': editShipmentForm.get('carrier_name')?.invalid && editShipmentForm.get('carrier_name')?.touched}">
                @if (editShipmentForm.get('carrier_name')?.invalid && editShipmentForm.get('carrier_name')?.touched) {
                  <p class="text-danger fs-10 fw-500">* Please enter a carrier name</p>
                }
              </div>
            </div>
          </div>

          <p class="fs-16 fw-600 hex-65-grey border-bottom pb-2 mb-3 mt-2">Dates &amp; Status</p>
          <div class="row">
            <div class="col-md-6 col-12">
              <div class="form-group">
                <label for="ship_date" class="fs-14 fw-400 m-0">Ship Date <span class="text-danger">*</span>(MM/DD/YYYY)</label>
                <div class="d-flex align-items-center input_field p-0 overflow-hidden">
                  <input type="text" id="ship_date" formControlName="ship_date" bsDatepicker readonly #shipDp="bsDatepicker"
                    [bsConfig]="dateConfig" placeholder="Choose a date"
                    class="input_field border-0 border-end m-0 flex-fill rounded-0" style="background: #ffffff;">
                  <div class="bg-transparent border-0 h-100 hw-40 d-flex align-items-center justify-content-center"
                    (click)="shipDp.toggle()">
                    <i class="fa fa-calendar"></i>
                  </div>
                </div>
                @if (editShipmentForm.get('ship_date')?.invalid && editShipmentForm.get('ship_date')?.touched) {
                  <p class="text-danger fs-10 fw-500">* Please select a ship date</p>
                }
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div class="form-group">
                <label for="est_delivery_date" class="fs-14 fw-400 m-0">Estimated Delivery <span class="text-danger">*</span>(MM/DD/YYYY)</label>
                <div class="d-flex align-items-center input_field p-0 overflow-hidden">
                  <input type="text" id="est_delivery_date" formControlName="est_delivery_date" bsDatepicker readonly
                    #deliveryDp="bsDatepicker" [bsConfig]="dateConfig" placeholder="Choose a date"
                    class="input_field border-0 border-end m-0 flex-fill rounded-0" style="background: #ffffff;">
                  <div class="bg-transparent border-0 h-100 hw-40 d-flex align-items-center justify-content-center"
                    (click)="deliveryDp.toggle()">
                    <i class="fa fa-calendar"></i>
                  </div>
                </div>
                @if (editShipmentForm.get('est_delivery_date')?.invalid && editShipmentForm.get('est_delivery_date')?.touched) {
                  <p class="text-danger fs-10 fw-500">* Please select an estimated delivery date</p>
                }
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div class="form-group">
                <label for="shipment_status" class="fs-14 fw-400 m-0">Status <span class="text-danger">*</span></label>
                <div class="input_field py-0">
                  <select id="shipment_status" formControlName="status" class="input_field selectType m-0 px-0 border-0"
                    [ngClass]="{'is-invalid': editShipmentForm.get('status')?.invalid && editShipmentForm.get('status')?.touched}">
                    <option value="" disabled selected>Please Select</option>
                    @for (option of shipmentStatuses; track option.value) {
                      <option [value]="option.value">{{option.label}}</option>
                    }
                  </select>
                </div>
                @if (editShipmentForm.get('status')?.invalid && editShipmentForm.get('status')?.touched) {
                  <p class="text-danger fs-10 fw-500">* Please select a status</p>
                }
              </div>
            </div>
            <div class="col-md-6 col-12 d-flex align-items-center">
              <div class="form-group m-0">
                <input tappable type="checkbox" class="secondary-checkbox" id="send_delivery_email"
                  formControlName="send_delivery_email">
                <label tappable class="fs-14 fw-500 m-0 hex-65-grey" for="send_delivery_email">Send Delivery Email</label>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="shipment_notes" class="fs-14 fw-400 m-0">Notes <span class="text-danger">*</span></label>
            <textarea id="shipment_notes" formControlName="notes" rows="4" placeholder="Enter notes"
              [maxlength]="shipmentNotesLimit" class="input_field"
              [ngClass]="{'is-invalid': editShipmentForm.get('notes')?.invalid && editShipmentForm.get('notes')?.touched}"></textarea>
            <div class="d-flex justify-content-between">
              @if (editShipmentForm.get('notes')?.invalid && editShipmentForm.get('notes')?.touched) {
                <p class="text-danger fs-10 fw-500 m-0">* Please enter a note</p>
              } @else {
                <span></span>
              }
              <span class="fs-10 fw-500 hex-65-grey">{{editShipmentForm.get('notes')?.value?.length || 0}}/{{shipmentNotesLimit}}</span>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <div class="d-flex justify-content-end w-100">
            <button type="button" class="btn btn-outline me-2" (click)="cancel()">Cancel</button>
            <button type="submit" class="btn btn-primary" [disabled]="editShipmentForm.invalid">Submit</button>
          </div>
        </div>
      </form>
    </div>
  </div>
}

@if (modalType == _assignmentsService.modalTypes.updateDeliveryModal) {
  <div class="modal-dialog modal-md">
    <div class="modal-content border-0">
      <form [formGroup]="updateDeliveryForm" (ngSubmit)="handleUpdateDelivery()">
        <div class="modal-header bg-primary d-flex align-items-center justify-content-between">
          <h4 class="modal-title text-white fs-18">Update Delivery Date</h4>
          <img src="assets/images/icons/white-cross.svg" alt="" (click)="cancel()" class="cursor hw-24">
        </div>
        <div class="modal-body">

          <div class="form-group">
            <label for="delivery_date" class="fs-14 fw-400 m-0">Delivery Date <span class="text-danger">*</span> (MM/DD/YYYY)</label>
            <div class="d-flex align-items-center input_field p-0 overflow-hidden">
              <input type="text" id="delivery_date" formControlName="delivery_date" bsDatepicker readonly
                #deliveryDateDp="bsDatepicker" [bsConfig]="dateConfig" placeholder="MM/DD/YYYY"
                class="input_field border-0 border-end m-0 flex-fill rounded-0" style="background: #ffffff;">
              <div class="bg-transparent border-0 h-100 hw-40 d-flex align-items-center justify-content-center"
                (click)="deliveryDateDp.toggle()">
                <i class="fa fa-calendar"></i>
              </div>
            </div>
            @if (updateDeliveryForm.get('delivery_date')?.invalid && updateDeliveryForm.get('delivery_date')?.touched) {
              <p class="text-danger fs-10 fw-500">* Please select a delivery date</p>
            }
          </div>

          <div class="form-group">
            <label for="delivery_status" class="fs-14 fw-400 m-0">Status <span class="text-danger">*</span></label>
            <div class="input_field py-0">
              <select id="delivery_status" formControlName="status" class="input_field selectType m-0 px-0 border-0"
                [ngClass]="{'is-invalid': updateDeliveryForm.get('status')?.invalid && updateDeliveryForm.get('status')?.touched}">
                <option value="" disabled selected>Please Select</option>
                @for (option of shipmentStatuses; track option.value) {
                  <option [value]="option.value">{{option.label}}</option>
                }
              </select>
            </div>
            @if (updateDeliveryForm.get('status')?.invalid && updateDeliveryForm.get('status')?.touched) {
              <p class="text-danger fs-10 fw-500">* Please select a status</p>
            }
          </div>

          <div class="form-group">
            <label for="delivery_notes" class="fs-14 fw-400 m-0">Notes <span class="text-danger">*</span></label>
            <textarea id="delivery_notes" formControlName="notes" rows="4" placeholder="Enter notes"
              [maxlength]="shipmentNotesLimit" class="input_field"
              [ngClass]="{'is-invalid': updateDeliveryForm.get('notes')?.invalid && updateDeliveryForm.get('notes')?.touched}"></textarea>
            <div class="d-flex justify-content-between">
              @if (updateDeliveryForm.get('notes')?.invalid && updateDeliveryForm.get('notes')?.touched) {
                <p class="text-danger fs-10 fw-500 m-0">* Please enter a note</p>
              } @else {
                <span></span>
              }
              <span class="fs-10 fw-500 hex-65-grey">{{updateDeliveryForm.get('notes')?.value?.length || 0}}/{{shipmentNotesLimit}}</span>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <div class="d-flex justify-content-end w-100">
            <button type="button" class="btn btn-outline me-2" (click)="cancel()">Cancel</button>
            <button type="submit" class="btn btn-primary" [disabled]="updateDeliveryForm.invalid">Submit</button>
          </div>
        </div>
      </form>
    </div>
  </div>
}

@if (modalType == _assignmentsService.modalTypes.editSerialNumberModal) {
  <div class="modal-dialog modal-md">
    <div class="modal-content border-0">
      <form [formGroup]="editSerialNumberForm" (ngSubmit)="handleEditSerialNumber()">
        <div class="modal-header bg-primary d-flex align-items-center justify-content-between">
          <h4 class="modal-title text-white fs-18">Edit Serial Number</h4>
          <img src="assets/images/icons/white-cross.svg" alt="" (click)="cancel()" class="cursor hw-24">
        </div>
        <div class="modal-body">

          <div class="form-group">
            <label for="edit_serial_number" class="fs-14 fw-400 m-0">Serial Number <span class="text-danger">*</span></label>
            <input type="text" id="edit_serial_number" formControlName="serial_number" class="input_field"
              placeholder="Enter serial number"
              [ngClass]="{'is-invalid': editSerialNumberForm.get('serial_number')?.invalid && editSerialNumberForm.get('serial_number')?.touched}">
            @if (editSerialNumberForm.get('serial_number')?.invalid && editSerialNumberForm.get('serial_number')?.touched) {
              <p class="text-danger fs-10 fw-500">* Please enter a serial number</p>
            }
          </div>

          <div class="form-group">
            <label for="serial_notes" class="fs-14 fw-400 m-0">Notes <span class="text-danger">*</span></label>
            <textarea id="serial_notes" formControlName="notes" rows="4" placeholder="Enter notes"
              [maxlength]="shipmentNotesLimit" class="input_field"
              [ngClass]="{'is-invalid': editSerialNumberForm.get('notes')?.invalid && editSerialNumberForm.get('notes')?.touched}"></textarea>
            <div class="d-flex justify-content-between">
              @if (editSerialNumberForm.get('notes')?.invalid && editSerialNumberForm.get('notes')?.touched) {
                <p class="text-danger fs-10 fw-500 m-0">* Please enter a note</p>
              } @else {
                <span></span>
              }
              <span class="fs-10 fw-500 hex-65-grey">{{editSerialNumberForm.get('notes')?.value?.length || 0}}/{{shipmentNotesLimit}}</span>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <div class="d-flex justify-content-end w-100">
            <button type="button" class="btn btn-outline me-2" (click)="cancel()">Cancel</button>
            <button type="submit" class="btn btn-primary" [disabled]="editSerialNumberForm.invalid">Submit</button>
          </div>
        </div>
      </form>
    </div>
  </div>
}
